"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
class Rule extends index_1.TopLevelNode {
    toJSON() {
        return {
            type: 'rule'
        };
    }
}
exports.Rule = Rule;
//# sourceMappingURL=rule.js.map